import React from "react";
import { Typography, Table } from "antd";
import "./TechAdvantages.css";
const { Title, Paragraph } = Typography;

const TechAdvantages = () => {
  const feedData = [
    { key: "1", property: "Gravity", value: "50 API" },
    { key: "2", property: "Viscosity", value: "1.9 cSt" },
    { key: "3", property: "Water", value: "< 0.1%" },
    { key: "4", property: "TSS (ppm)", value: "100-200" },
    { key: "5", property: "Avg Hg (ppbw)", value: "3300" },
  ];

  const operationData = [
    { key: "1", property: "Capacity (BPOD)", value: "6500" },
    { key: "2", property: "Residence time (min.)", value: "15-30" },
    { key: "3", property: "Total avg Hg removal", value: "> 98%" },
    { key: "4", property: "Oil losses", value: "0.2 - 0.3%" },
    { key: "5", property: "Hg removed/mo. (kg)", value: "50" },
    { key: "6", property: "Filter turnaround time (min.)", value: "20" },
  ];

  const columns = [
    {
      title: "",
      dataIndex: "property",
      key: "property",
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
    },
  ];

  const advantages = [
    "Reduces Hg in crudes and condensates",
    "Proven commercially",
    "Robust process design",
    "Reliable operation",
    "Modest investment and operating costs",
    "Hg removed can be easily transferred to environmentally acceptable disposal",
  ];

  return (
    <div>
      <Title level={1}>Tech Advantages</Title>
      <img 
        src="/images/deslurrying-web.jpg"
        alt="slurrying hydro-cracker"
      />
      <ol>
        {advantages.map((advantage, index) => (
          <li key={index}>{advantage}</li>
        ))}
      </ol>
      <Title level={4}>MERCAWAY Process Commercial Case</Title>
      <Paragraph className="common-paragraph">
        MERCAWAY™ process technology was commercialized with the 2006 startup of
        a Chevron-licensed unit for a client in Argentina. This MERCAWAY
        process unit has operated reliably with minimal downtime. The MERCAWAY
        unit disposes the filter cake by slurrying with produced water and
        injecting back underground in a closed system, reducing the risk of
        exposure to their operations and maintenance personnel.
      </Paragraph>
      <Paragraph className="common-paragraph">
        <b>The unit's design basis and operation information are as noted below</b>{" "}
        (data sourced from a presentation to LACPEC, Lima, 3-1-2010 by Carlos
        Salvá & Darrell Gallup).
      </Paragraph>
      <Table
        className="Antd-Table"
        dataSource={feedData}
        columns={columns}
        pagination={false}
        title={() => "FEED: Black oil condensate (paraffinic with some asphaltenes)"}
        
      />
      <Table
        className="Antd-Table"
        dataSource={operationData}
        columns={columns}
        pagination={false}
        title={() => "Operation"}
      />
      <Title level={5}>Experience Over a 30-Day Period</Title>
      <Paragraph className="common-paragraph">
        The MERCAWAY unit has operated robustly, reliably and successfully since
        2006 while consistently reducing total Hg levels to less than 50 ppbw.
        Our MERCAWAY process operates at modest temperature and pressure while
        using relatively uncomplicated, well-understood processing steps. There
        is no requirement for special metallurgy. Oil losses are quite low with
        less than 0.5 percent oil loss due to the filtration system employed.
        Chevron has the expertise to support your efforts to reduce crude Hg to
        acceptable levels by employing our MERCAWAY process technology. We look
        forward to hearing from you and, upon request, we will be pleased to
        prepare MERCAWAY commercial and technical proposals for your evaluation
        of our licensing terms and technical services that we can offer.
      </Paragraph>
    </div>
  );
};

export default TechAdvantages;
